import { render, staticRenderFns } from "./StatItem.vue?vue&type=template&id=ea7e2e96&scoped=true&"
import script from "./StatItem.vue?vue&type=script&lang=js&"
export * from "./StatItem.vue?vue&type=script&lang=js&"
import style0 from "./StatItem.vue?vue&type=style&index=0&id=ea7e2e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7e2e96",
  null
  
)

export default component.exports